import React, { ReactElement, useRef } from 'react';
import Radio, { RadioProps } from "../input/Radio";
import { useField } from "formik";
import { PdsRadioGroup } from "@principal/design-system-react";

const _ = require("lodash");

export type RadioGroupProps = {
    id: string,
    label?: string,
    labelContent?: ReactElement,
    required?: boolean,
    radioProps: Pick<RadioProps, "id" | "text" | "changeCallback">[]
}

const RadioGroup = (props: RadioGroupProps) => {
    const name = _.camelCase(props.id);
    const [, meta] = useField({
        name: name,
        validate: validateInput
    });
    const groupRef = useRef(null as any as HTMLDivElement)
    const fieldRemoved = meta.initialValue === undefined;
    const error = meta.error;

    return (fieldRemoved ? null :
            <div className="pds-u-margin-bottom-16" ref={groupRef}>
                <PdsRadioGroup id={props.id} fieldId={props.id} name={name} label={props.label} required={props.required} errorMessage={error}>
                    <div className="pds-u-padding-left-16">
                        {props.radioProps.map(o => {
                            const radioId = `${props.id}-${o.id}`;
                            return <Radio id={radioId} key={radioId} name={name} text={o.text} changeCallback={o.changeCallback}/>;
                        })}
                    </div>
                    <label slot="label" data-field-name={name} data-field-label={props.label} htmlFor={props.id}>
                        {props.label}{props.labelContent}
                    </label>
                </PdsRadioGroup>
            </div>
    )

    function validateInput(value: string) {
        const groupRefCurrent = groupRef?.current;
        if(fieldRemoved || !groupRefCurrent) {
            return '';
        }
        const priorOrCurrentStep = groupRefCurrent?.closest('.prior-step, .current-step');
        const invisible = groupRefCurrent?.closest('.invisible');
        const required = props.required;
        if((priorOrCurrentStep && invisible && !value) || groupRefCurrent?.closest('.future-step')) {
            return '';
        } else if(required && !value) {
            return 'Please select an option.'
        }
        return '';
    }
};
export default RadioGroup;